<template>
    <div>
        <div id="login_welcome">
            <div id="two_fa_icon"></div>
            <div id="login_welcome_message">{{ $t('[x] RSA Login').replace('[x]', $t('PRODUCT')) }}</div>
            <div id="login_content_message">{{ $t('RSA_HELP') }}</div>
        </div>
        <div id="login_content">
            <ul id="login_credentials">
                <li>
                    <label class="login-label">{{ $t('Tokencode') }}</label>
                    <cic-textbox
                        id="password"
                        :value="value"
                        type="password"
                        @keyup.enter="$emit('change')"
                        @input="(val) => $emit('input', val)"
                    />
                    <label class="login-explain">{{ $t('Please enter your 6 digit code') }}</label>
                </li>
            </ul>

            <div class="cic-control-bar">
                <cic-button class="ok" @click="$emit('change')">
                    {{ $t('Login') }}
                </cic-button>
            </div>
        </div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'RsaChallenge',
        components: {
            CicButton,
            CicTextbox,
        },
        props: {
            value: {
                type: String,
                required: true,
            },
        },
        emits: ['change', 'input'],
    };
</script>
